import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { FormInput, FormWrapper } from '../../Form/FormInput';
import { prop } from '../../../../utilities';
import { Select } from '../../General/Select';
import { TextP } from '../../../Defaults/Text';
import { DsiCheckBox } from '../../General/Checkbox';

interface Props {
  formProblems?: any;
  onBlur: (fieldName: string, value: string) => void;
}

function Register({ formProblems, onBlur }: Props) {
  const { passwordProblem, passwordAgainProblem } = {
    passwordProblem: prop(formProblems, 'password'),
    passwordAgainProblem: prop(formProblems, 'password_again'),
  };

  const [password, setPassword] = React.useState('');
  const [passwordAgain, setPasswordAgain] = React.useState('');

  return (
    <Wrapper>
      <PasswordWrapper>
        <FormInput
          name="password"
          type="password"
          label={__('Heslo')}
          required
          marginBottom={16}
          minWidthPx={288}
          marginRight={32}
          validMessage={passwordProblem}
          validateAllowedChars
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onBlur={() => onBlur('password', password)}
        />
        <FormInput
          name="password_again"
          type="password"
          required
          label={__('Heslo znovu')}
          minWidthPx={288}
          marginBottom={16}
          validMessage={passwordAgainProblem}
          validateAllowedChars
          value={passwordAgain}
          onChange={(e) => setPasswordAgain(e.target.value)}
          onBlur={() => onBlur('password_again', passwordAgain)}
        />
      </PasswordWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin: ${rem(24)} 0 0 0;
`;

const EmptyWrapper = styled.div`
  margin-bottom: ${rem(24)};
`;

const NameWrapper = styled(FlexRow)`
  flex-flow: row wrap;
`;

const AddressWrapper = styled(FlexRowCenterVertical)<{ isB2B?: boolean }>`
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row wrap')};
  align-items: ${({ isB2B }) => (isB2B ? 'flex-start' : 'center')};
`;

const Text = styled(TextP)`
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(38)};
  margin-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
  `}
`;

const PasswordWrapper = styled(FlexRow)`
  flex-flow: row wrap;
`;

export { Register };